import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { clearPostLoginPath, readPostLoginPath } from './postLoginPath';

type Props = { children: React.ReactElement };

/** Возвращает только что вошедшего пользователя на страницу, с которой он нажал «Войти». */
const PostLoginRedirect: React.FC<Props> = ({ children }) => {
  const target = readPostLoginPath();

  useEffect(() => {
    if (target) clearPostLoginPath();
  }, [target]);

  return target ? <Navigate to={target} replace /> : children;
};

export default PostLoginRedirect;
